/* eslint-disable react/jsx-props-no-spreading */
import {
  Autocomplete,
  TextField,
  AutocompleteProps,
  SxProps,
  Theme,
} from "@mui/material";

interface CustomizedAutocompleteProps<T> extends Omit<
  AutocompleteProps<T, false, false, false>,
  "renderInput" | "sx"
> {
  label: string;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

const CustomizedAutocomplete = <T,>({
  label,
  placeholder = "",
  sx = {},
  ...autocompleteProps
}: CustomizedAutocompleteProps<T>) => {
  return (
    <Autocomplete<T, false, false, false>
      {...autocompleteProps}
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          paddingRight: "8px",
          backgroundColor: "background.paper",
          transition: "all 0.2s ease-in-out",
          "& fieldset": {
            borderColor: "grey.300",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
            borderWidth: 2,
          },
        },
        "& .MuiAutocomplete-input": {
          padding: "8px 12px",
          fontSize: "0.875rem",
        },
        "& .MuiAutocomplete-endAdornment": {
          right: 8,
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.875rem",
          fontWeight: 500,
          "&.Mui-focused": {
            color: "primary.main",
          },
        },
        ...sx,
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        const displayValue =
          typeof autocompleteProps.getOptionLabel === "function"
            ? autocompleteProps.getOptionLabel(option)
            : "";

        return (
          <li
            key={key}
            {...otherProps}
            style={{
              padding: "10px 16px",
              fontSize: "0.875rem",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            {displayValue}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
    />
  );
};

export default CustomizedAutocomplete;
